module.exports = __webpack_public_path__ + "img/blkbill_cptblackbill.a9716e0.png";